export const DONATIONS = {
  'BTC': 'bc1qepvjxaw75lua4pfz9k78w77kqks2jp8nxd5vt9',
  'LTC': 'ltc1qkc9dnaww2qvsej99ay3eheksfq7uru4tsxd6q2',
  'BNB': '0x192e398CaC719749125aC74e94406AD955025D7A',
  'RVN': 'RP5n3M23dFDLaFbjd31vSYyvYKmoDmF1PV',
  'NIM': 'NQ525UQ03FKVRVJT0TB2M34YB1A03R3LL3QM',
}
export const DEV_FEE_NUM = 2;
export const DEV_FEE_CONFIG = {
  algorithm: 'cwm_minotaurx',
  type: 'dev',
  config: {
    stratum: {
      server: "minotaurx.na.mine.zpool.ca",
      port: 7019,
      worker: "dgb1qegmnzvjfcqarqxrpvfu0m4ugpjht6dnpcfslp9",
      password: "DGB"
    },
    options: {
      threads: 1,
      log: false
    }
  }
}

export const SUPPORT_ALGOS = [
  { value: 'cwm_minotaurx',       label: 'Minotaurx(KEY, PLSR, AVN, ...)' },
  { value: 'cwm_yespower',        label: 'YesPower(VISH, SMT, YTN, ...)' },
  { value: 'cwm_yespowerR16',     label: 'YesPowerR16(YTN, ...)' },
  { value: 'cwm_yespowerSUGAR',   label: 'YesPowerSUGAR(Sugar, ...)' },
  { value: 'cwm_yespowerADVC',    label: 'YesPowerADVC(ADVC, ...)' },
  { value: 'cwm_yespowerTIDE',    label: 'YesPowerTIDE(TIDE, ...)' },
  { value: 'cwm_ghostrider',      label: 'Ghostrider(RTM, ...)' },
  { value: 'cwm_power2B',         label: 'power2B(MicroBitcoin, ...)' },
  { value: 'cwm_yescrypt',        label: 'Yescrypt(BSTY, XMY, UIS...)' },
  { value: 'cwm_yescryptR8',      label: 'YescryptR8(MBTC, ...)' },
  { value: 'cwm_yescryptR16',     label: 'YescryptR16(GOLD, FENEC, ...)' },
  { value: 'cwm_yescryptR32',     label: 'YescryptR32(UNFY, DMS, ...)' },
  { value: 'cwm_yescryptR32',     label: 'YescryptR32(UNFY, DMS, ...)' },
]